var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "detail-table-container" },
    [
      _vm.updateGuide ? _c("div", { staticClass: "updateGuide" }) : _vm._e(),
      _c("div", { staticClass: "btns" }, [
        _c(
          "div",
          { staticClass: "btn-left" },
          [
            _c(
              "el-button",
              {
                staticClass: "wl-green",
                style: {
                  zIndex:
                    _vm.updateGuide && _vm.updateGuideStep == 3 ? 2004 : 0,
                },
                attrs: {
                  id: "printConfirmation",
                  disabled: !_vm.hasPermission("download"),
                  icon: "el-icon-printer",
                },
                on: { click: _vm.onPrintConfirmationClick },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t(
                        "confirmation.details_list.btns.print_confirmation"
                      )
                    ) +
                    "\n            "
                ),
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "wl-green",
                style: {
                  zIndex:
                    _vm.updateGuide && _vm.updateGuideStep == 3 ? 2004 : 0,
                },
                attrs: { id: "statusByBatch", icon: "el-icon-edit" },
                on: { click: _vm.updateStatusByBatch },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("confirmation.details_list.btns.update_status")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.getUser.userType == "1",
                    expression: "getUser.userType == '1'",
                  },
                ],
                staticClass: "wl-green reprint-btn",
                attrs: { icon: "el-icon-message" },
                on: { click: _vm.onReprintClick },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("confirmation.details_list.btns.reprint")) +
                    "\n                "
                ),
                _c("div", { class: ["new-tag", `new_${_vm.$i18n.locale}`] }),
              ]
            ),
            _vm.updateGuide && [3].includes(_vm.updateGuideStep)
              ? _c(
                  "div",
                  {
                    class: [
                      "updateGuideTitle",
                      `updateGuideTitle-step${_vm.updateGuideStep}`,
                    ],
                    style: {
                      left: `${_vm.updateGuideTitle3Left}PX`,
                      width: `${_vm.updateGuideTitle3Width}PX`,
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "updateGuideTip" },
                      [
                        _c("div", { staticClass: "margin-bottom-10" }, [
                          _vm._v(_vm._s(_vm.updateGuideStep) + "/5"),
                        ]),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("confirmation_bubble_3")),
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            staticClass: "guide-btn",
                            on: { click: _vm.nextClick },
                          },
                          [_vm._v(_vm._s(_vm.$t("next")))]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                staticClass: "wl-green",
                attrs: {
                  id: "downloadConfirmation",
                  disabled: !_vm.hasPermission("download"),
                  icon: "el-icon-download",
                },
                on: { click: _vm.onDownloadConfirmationClick },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("BATCH_DOWNLOAD")) +
                    "\n                "
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.$t("confirmation_cannot_download_tip"),
                    },
                  },
                  [
                    !_vm.hasPermission("download")
                      ? _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: { color: "#fd349c" },
                        })
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "btn-right" },
          [
            _c(
              "el-button",
              {
                staticClass: "wl-green",
                attrs: { disabled: !_vm.hasPermission("download") },
                on: { click: _vm.exportList },
              },
              [
                _c("img", {
                  staticClass: "btn-icon icon-hover",
                  attrs: {
                    src: require("@/assets/img/icon-export.svg"),
                    width: "100%",
                  },
                }),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("confirmation.details_list.btns.export_list")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _c(
              "div",
              {
                class: [
                  _vm.showSearchParams
                    ? "filter-and-config"
                    : "filter-and-config-without-params",
                ],
              },
              [
                _c(
                  "TableColumnsControl",
                  {
                    class: [
                      "table-column-config",
                      _vm.anyHidden ? "table-column-config-active" : "",
                    ],
                    attrs: {
                      tableName:
                        _vm.getUser.userType === "1"
                          ? "cfmt_dtl_lst"
                          : "cfmt_dtl_lst_client",
                      onColumnsLoad: _vm.onColumnsLoad,
                      anyHidden: _vm.anyHidden,
                    },
                    on: {
                      "update:anyHidden": function ($event) {
                        _vm.anyHidden = $event
                      },
                      "update:any-hidden": function ($event) {
                        _vm.anyHidden = $event
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "column-btn" }, [
                      _c("img", {
                        staticClass: "table-setting-icon",
                        attrs: {
                          src: require("@/assets/img/icon-table-setting.svg"),
                          width: "100%",
                        },
                      }),
                      _c("span", { staticClass: "table-setting-text" }, [
                        _vm._v(_vm._s(_vm.$t("table_columns_display_btn"))),
                      ]),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "split" }),
                _c(
                  "div",
                  {
                    class: [
                      "clean-filter",
                      _vm.cleanFilterActive ? "clean-filter-active" : "",
                    ],
                    on: { click: _vm.clearFilter },
                  },
                  [
                    _c("img", {
                      staticClass: "table-setting-icon",
                      attrs: { src: require("@/assets/img/icon-screen.svg") },
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("clear_filter")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "12px",
            color: "#fd349c",
            "font-weight": "bold",
          },
        },
        [_vm._v(_vm._s(_vm.$t("confirmation.details_list.operate_tip")))]
      ),
      _vm.updateGuide && [2, 4].includes(_vm.updateGuideStep)
        ? _c(
            "div",
            {
              class: [
                "updateGuideTitle",
                `updateGuideTitle-step${_vm.updateGuideStep}`,
              ],
              style: {
                height: `${_vm.updateGuideTitleHeight}px`,
                left: `${_vm.statusLeft}px`,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "updateGuideTip",
                  style: { top: `${_vm.updateGuideTitleHeight + 10}px` },
                },
                [
                  _c("div", { staticClass: "margin-bottom-10" }, [
                    _vm._v(_vm._s(_vm.updateGuideStep) + "/5"),
                  ]),
                  _c("div", { staticClass: "margin-bottom-10" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(`confirmation_bubble_${_vm.updateGuideStep}`)
                      )
                    ),
                  ]),
                  _c(
                    "el-button",
                    { staticClass: "guide-btn", on: { click: _vm.nextClick } },
                    [_vm._v(_vm._s(_vm.$t("next")))]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { class: "table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.list.loading,
                  expression: "list.loading",
                },
              ],
              key: _vm.tableKey,
              ref: "confirmationTable",
              attrs: {
                data: _vm.list.data,
                height: "100%",
                stripe: "",
                border: "",
                "header-cell-class-name": _vm.updateGuideClass,
              },
              on: {
                "select-all": (e) => _vm.handleSelectAll(e, _vm.list.data),
                select: _vm.handleSelect,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "40",
                  fixed: _vm.bodyWrapperScrollLeft > 60 ? "left" : false,
                },
              }),
              _vm.showColumns.includes("ticketNo") &&
              _vm.getUser.userType == "1"
                ? _c("el-table-column", {
                    attrs: { width: 120, "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.ticketNo"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter.ticketNo
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        565832706
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.ticketNo.input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.ticketNo,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.ticketNo.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm.headerFilterTicketNoOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .ticketNo,
                                                                  _vm.headerFilterTicketNoOpt,
                                                                  true
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .ticketNo,
                                                                  _vm.headerFilterTicketNoOpt,
                                                                  false
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter.ticketNo
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter.ticketNo,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.ticketNo.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterTicketNoOpt,
                                                    function (v) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: v,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: { label: v },
                                                        },
                                                        [_vm._v(_vm._s(v))]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "td" }, [
                                _c(
                                  "span",
                                  { staticClass: "overflow-tooltip-cls" },
                                  [_vm._v(_vm._s(scope.row.ticketNo))]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3133124379
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("uniqueId")
                ? _c("el-table-column", {
                    attrs: { width: 200 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", {
                                    staticClass: "th-label",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.unique_id"
                                        )
                                      ),
                                    },
                                  }),
                                  _c(
                                    "el-popover",
                                    {
                                      ref: "uniqueIdPopper",
                                      attrs: { placement: "bottom" },
                                      on: {
                                        hide: function ($event) {
                                          return _vm.filterUniqueId(
                                            _vm.filter.uniqueId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("template", { slot: "reference" }, [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter-down" },
                                          [
                                            _c("i", {
                                              class: [
                                                "el-icon-arrow-down",
                                                _vm.filter.uniqueId.unPrint ||
                                                (_vm.filter.uniqueId.input &&
                                                  _vm.filter.uniqueId.input
                                                    .length > 0)
                                                  ? "el-icon-arrow-down-active"
                                                  : "",
                                              ],
                                            }),
                                          ]
                                        ),
                                      ]),
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.filter.uniqueId.unPrint,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filter.uniqueId,
                                                  "unPrint",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filter.uniqueId.unPrint",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "confirmation.details_list.not_print"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-input" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                rows: 5,
                                                resize: "none",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.uniqueId.input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.uniqueId,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.uniqueId.input",
                                              },
                                            }),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.filter.uniqueId.input
                                                      .length > 0,
                                                  expression:
                                                    "filter.uniqueId.input.length > 0",
                                                },
                                              ],
                                              staticClass:
                                                "el-icon-circle-close clear-btn",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.filter.uniqueId.input = ""
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "header-btn-position",
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "wl-green",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.filterUniqueId(
                                                      _vm.filter.uniqueId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("btn_search2"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "td" },
                                [
                                  scope.row.status === "1" ||
                                  !_vm.hasPermission("download")
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.uniqueId)),
                                      ])
                                    : [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "icon-preview uniqueId-text",
                                            attrs: { title: _vm.$t("preview") },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onPdfPrintClick(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-view",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "uniqueId-text",
                                            on: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-download",
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "uniqueId-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.uniqueId)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                  _vm.ifPrint(scope.row)
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.$t("printed"))),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2691156789
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("type")
                ? _c("el-table-column", {
                    attrs: { width: 150, "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.confirmation_type"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter.type
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1685524607
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.filter.type.input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.type,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression: "filter.type.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm.headerFilterKPResponsibleOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .type,
                                                                  _vm.headerFilterTypeOpt,
                                                                  true,
                                                                  "code"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .type,
                                                                  _vm.headerFilterTypeOpt,
                                                                  false,
                                                                  "code"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter.type
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter.type,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.type.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterTypeOpt,
                                                    function (v) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: v.code,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: {
                                                            label: v.code,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                `confirmation_type._${v.code}`
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  class: [
                                    "td",
                                    "confirmation_type_" + scope.row.type,
                                  ],
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "overflow-tooltip-cls" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            `confirmation_type._${scope.row.type}`
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3182727218
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("confirmationEntityName")
                ? _c("el-table-column", {
                    attrs: { width: 130, "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.entity_name"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        "popper-class": "column3-popover",
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .confirmationEntityName
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        160806900
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter
                                                    .confirmationEntityName
                                                    .input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter
                                                      .confirmationEntityName,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.confirmationEntityName.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm.headerFilterEntityNameOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .confirmationEntityName,
                                                                  _vm.headerFilterEntityNameOpt,
                                                                  true,
                                                                  "id"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .confirmationEntityName,
                                                                  _vm.headerFilterEntityNameOpt,
                                                                  false,
                                                                  "id"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter
                                                          .confirmationEntityName
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter
                                                            .confirmationEntityName,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.confirmationEntityName.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterEntityNameOpt,
                                                    function (v) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: v.id,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: {
                                                            label: v.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(v.entityName)
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                { staticClass: "overflow-tooltip-cls" },
                                [
                                  _vm._v(
                                    _vm._s(scope.row.confirmationEntityName)
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1485815183
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("addrEntityName")
                ? _c("el-table-column", {
                    attrs: { "min-width": 130, "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.addressee_entity_name"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        "popper-class": "column3-popover",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .addressEntityName
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3056379949
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.addressEntityName
                                                    .input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter
                                                      .addressEntityName,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.addressEntityName.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm
                                                  .headerFilterAddressEntityNameOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .addressEntityName,
                                                                  _vm.headerFilterAddressEntityNameOpt,
                                                                  true,
                                                                  null
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .addressEntityName,
                                                                  _vm.headerFilterAddressEntityNameOpt,
                                                                  false,
                                                                  null
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter
                                                          .addressEntityName
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter
                                                            .addressEntityName,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.addressEntityName.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterAddressEntityNameOpt,
                                                    function (v, k) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: k,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: { label: v },
                                                        },
                                                        [_vm._v(_vm._s(v))]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "td",
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  scope.row.uniqueId.startsWith("E") &&
                                  scope.row.confirmationType !== "Conf_Com"
                                    ? [
                                        _vm.pdfNameMap[
                                          scope.row.addrEntityName.slice(0, 6)
                                        ]
                                          ? _c(
                                              "a",
                                              {
                                                staticStyle: {
                                                  "margin-right": "3px",
                                                  "font-size": "16px",
                                                  color: "#3879eb",
                                                },
                                                attrs: {
                                                  href:
                                                    "/static/confirmation/" +
                                                    _vm.pdfNameMap[
                                                      scope.row.addrEntityName.slice(
                                                        0,
                                                        6
                                                      )
                                                    ],
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-link",
                                                }),
                                              ]
                                            )
                                          : _c("i", {
                                              staticClass: "el-icon-link",
                                              staticStyle: {
                                                "margin-right": "3px",
                                                "font-size": "16px",
                                                cursor: "not-allowed",
                                              },
                                              attrs: { title: "找不到文件" },
                                            }),
                                      ]
                                    : _vm._e(),
                                  scope.row.confirmationType === "Conf_Com"
                                    ? _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "margin-right": "3px",
                                            "font-size": "16px",
                                            color: "#3879eb",
                                          },
                                          attrs: {
                                            href: "/static/confirmation/Client Authorization Instructions (Confirmation.com).pdf",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-link",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    { staticClass: "overflow-tooltip-cls" },
                                    [_vm._v(_vm._s(scope.row.addrEntityName))]
                                  ),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4251398010
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("balanceSheetDateStamp")
                ? _c("el-table-column", {
                    attrs: { width: 180 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.balance_sheet_date"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "balanceSheetDate"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.order.balanceSheetDate == "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.order.balanceSheetDate == "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        "popper-class": "column3-popover",
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .balanceSheetDate
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        31888058
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.balanceSheetDate
                                                    .input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.balanceSheetDate,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.balanceSheetDate.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm
                                                  .headerFilterBalanceSheetDateOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .balanceSheetDate,
                                                                  _vm.headerFilterBalanceSheetDateOpt,
                                                                  true,
                                                                  null
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .balanceSheetDate,
                                                                  _vm.headerFilterBalanceSheetDateOpt,
                                                                  false,
                                                                  null
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter
                                                          .balanceSheetDate
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter
                                                            .balanceSheetDate,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.balanceSheetDate.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterBalanceSheetDateOpt.slice(
                                                      0,
                                                      1000
                                                    ),
                                                    function (v, k) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: k,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: { label: v },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDate"
                                                              )(v)
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "td" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        scope.row.balanceSheetDateStamp
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2727901146
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("status")
                ? _c("el-table-column", {
                    attrs: { width: 210, "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c(
                                    "el-dropdown",
                                    {
                                      staticStyle: { "margin-right": "5px" },
                                      on: { command: _vm.onStatusBatchEdit },
                                    },
                                    [
                                      _c("div", { staticClass: "th-edit" }, [
                                        _c("i", {
                                          staticClass: "el-icon-edit-outline",
                                        }),
                                      ]),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _vm._l(
                                            _vm.options
                                              .confirmationStatusOptions,
                                            function (v, k) {
                                              return [
                                                v.code === "3"
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        key: k,
                                                        attrs: {
                                                          command: v.code,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              v.code === "3"
                                                                ? _vm.$t(
                                                                    `confirmation_status._3_3`
                                                                  )
                                                                : _vm.$t(
                                                                    `confirmation_status._${v.code}`
                                                                  )
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.client_authorisation_status"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("status")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.order.status == "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.order.status == "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter.status
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1866653523
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.filter.status.input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.status,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.status.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm.headerFilterStatusOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .status,
                                                                  _vm.headerFilterStatusOpt,
                                                                  true,
                                                                  "code"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .status,
                                                                  _vm.headerFilterStatusOpt,
                                                                  false,
                                                                  "code"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter.status
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter.status,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.status.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterStatusOpt,
                                                    function (v) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: v.code,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: {
                                                            label: v.code,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                v.code === "3"
                                                                  ? _vm.$t(
                                                                      `confirmation_status._3_3`
                                                                    )
                                                                  : _vm.$t(
                                                                      `confirmation_status._${v.code}`
                                                                    )
                                                              ) +
                                                              "\n                                            "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                scope.row.status === "2"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "confirmation_status_bg_2",
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            on: {
                                              change: function ($event) {
                                                return _vm.singleEditStatus(
                                                  scope.row
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.status",
                                            },
                                          },
                                          [
                                            _vm._l(
                                              _vm.options
                                                .confirmationStatusOptions,
                                              function (v, k) {
                                                return [
                                                  v.code === "2" ||
                                                  v.code === "3"
                                                    ? _c(
                                                        "el-option",
                                                        {
                                                          key: k,
                                                          attrs: {
                                                            label: _vm.$t(
                                                              `confirmation_status._${v.code}`
                                                            ),
                                                            value: v.code,
                                                            disabled:
                                                              scope.row.uniqueId.startsWith(
                                                                "E"
                                                              ) &&
                                                              v.code === "3",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                v.code === "3"
                                                                  ? _vm.$t(
                                                                      `confirmation_status._3_3`
                                                                    )
                                                                  : _vm.$t(
                                                                      `confirmation_status._${v.code}`
                                                                    )
                                                              ) +
                                                              "\n                                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "span",
                                      {
                                        class: [
                                          "overflow-tooltip-cls",
                                          `confirmation_status_bg_${scope.row.status}`,
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              scope.row.status === "3"
                                                ? _vm.$t(
                                                    `confirmation_status._3_3`
                                                  )
                                                : _vm.$t(
                                                    `confirmation_status._${scope.row.status}`
                                                  )
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2039314901
                    ),
                  })
                : _vm._e(),
              _vm.getUser.userType === "1" &&
              _vm.showColumns.includes("confirmationStatus")
                ? _c("el-table-column", {
                    attrs: {
                      width: 340,
                      "show-overflow-tooltip": "",
                      id: "confirmationStatus",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "th" }, [
                                _c("div", {
                                  staticClass: "th-label",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "confirmation.details_list.table.confirmation_status_no_br"
                                      )
                                    ),
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "th-sort",
                                    on: {
                                      click: function ($event) {
                                        return _vm.switchSort(
                                          "confirmationStatus"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-caret-top th-sort-up",
                                      class: [
                                        _vm.order.confirmationStatus == "asc"
                                          ? "th-sort-active"
                                          : "",
                                      ],
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-caret-bottom th-sort-down",
                                      class: [
                                        _vm.order.confirmationStatus == "desc"
                                          ? "th-sort-active"
                                          : "",
                                      ],
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "td" }, [
                                _c(
                                  "span",
                                  { staticClass: "overflow-tooltip-cls" },
                                  [_vm._v(_vm._s(scope.row.confirmationStatus))]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1024558876
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("currentStatusTimeStamp")
                ? _c("el-table-column", {
                    attrs: { width: 320 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.current_status_time"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "currentStatusTime"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.order.currentStatusTime == "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.order.currentStatusTime == "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .currentStatusTime
                                                          .range &&
                                                        _vm.filter
                                                          .currentStatusTime
                                                          .range.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1973398632
                                      ),
                                    },
                                    [
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "daterange",
                                            format: "yyyy-MM-dd",
                                            "value-format": "yyyy-MM-dd",
                                            "start-placeholder":
                                              _vm.$t("date_filter_begin"),
                                            "end-placeholder":
                                              _vm.$t("date_filter_end"),
                                            "range-separator":
                                              _vm.$t("date_filter_middle"),
                                          },
                                          model: {
                                            value:
                                              _vm.filter.currentStatusTime
                                                .range,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filter.currentStatusTime,
                                                "range",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filter.currentStatusTime.range",
                                          },
                                        }),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "td" },
                                [
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatDateTime")(
                                                scope.row.currentStatusTimeStamp
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatDate")(
                                              scope.row.currentStatusTimeStamp
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3878719574
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("clientInchargeList")
                ? _c("el-table-column", {
                    attrs: { width: 320 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.client_responsible_person"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        "popper-class": "column3-popover",
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .clientIncharge
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3236642627
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.clientIncharge
                                                    .input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.clientIncharge,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.clientIncharge.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm
                                                  .headerFilterClientInchargeOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .clientIncharge,
                                                                  _vm.headerFilterClientInchargeOpt,
                                                                  true,
                                                                  "userId"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .clientIncharge,
                                                                  _vm.headerFilterClientInchargeOpt,
                                                                  false,
                                                                  "userId"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter
                                                          .clientIncharge
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter
                                                            .clientIncharge,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.clientIncharge.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterClientInchargeOpt,
                                                    function (v) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: v.userId,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: {
                                                            label: v.userId,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(v.userName)
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._l(
                                scope.row.clientInchargeList,
                                function (v, k) {
                                  return [
                                    v.userAccount
                                      ? _c(
                                          "el-popover",
                                          {
                                            key: k,
                                            attrs: {
                                              placement: "right",
                                              trigger: "hover",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "reference" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "single-item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(v.userName) +
                                                        "\n                                    "
                                                    ),
                                                    k !==
                                                    scope.row.clientInchargeList
                                                      .length -
                                                      1
                                                      ? _c("span", [
                                                          _vm._v(","),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "single-item-hover",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(v.userAccount) +
                                                      "\n                                    "
                                                  ),
                                                  _c("img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/img/kpicon-copy.svg"),
                                                      width: "100%",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.doCopy(
                                                          v.userAccount
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                          ],
                                          2
                                        )
                                      : _c(
                                          "span",
                                          {
                                            key: k,
                                            staticClass: "single-item",
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(v.userName) +
                                                "\n                            "
                                            ),
                                            k !==
                                            scope.row.clientInchargeList
                                              .length -
                                              1
                                              ? _c("span", [_vm._v(",")])
                                              : _vm._e(),
                                          ]
                                        ),
                                  ]
                                }
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2225651508
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("kpInchargeList")
                ? _c("el-table-column", {
                    attrs: { width: 220, "class-name": "multi-email-column" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.kpmg_responsible_person"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        "popper-class": "column3-popover",
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .kpInchargeList
                                                          .multiCheck.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3242212387
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                "prefix-icon": "el-icon-search",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.kpInchargeList
                                                    .input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.kpInchargeList,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.kpInchargeList.input",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "th-filter-checkbox-group",
                                              },
                                              [
                                                _vm.headerFilterKPResponsibleOpt
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "header-select-all",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .kpInchargeList,
                                                                  _vm.headerFilterKPResponsibleOpt,
                                                                  true,
                                                                  "userId"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "select_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onThFilterCheckAllChange(
                                                                  _vm.filter
                                                                    .kpInchargeList,
                                                                  _vm.headerFilterKPResponsibleOpt,
                                                                  false,
                                                                  "userId"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unselect_all"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "el-checkbox-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filter
                                                          .kpInchargeList
                                                          .multiCheck,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.filter
                                                            .kpInchargeList,
                                                          "multiCheck",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.kpInchargeList.multiCheck",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.headerFilterKPResponsibleOpt,
                                                    function (v) {
                                                      return _c(
                                                        "el-checkbox",
                                                        {
                                                          key: v.userId,
                                                          staticClass:
                                                            "th-filter-checkbox",
                                                          attrs: {
                                                            label: v.userId,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(v.userName)
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "right",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("template", { slot: "reference" }, [
                                    _c(
                                      "span",
                                      { staticClass: "overflow-tooltip-cls" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              scope.row.kpInchargeList
                                                .map((i) => i.userName)
                                                .join(";")
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._l(
                                    scope.row.kpInchargeList,
                                    function (v) {
                                      return _c(
                                        "div",
                                        { staticClass: "single-item-hover" },
                                        [
                                          scope.row.kpInchargeList.length <= 1
                                            ? [
                                                v.email
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            "(" + v.email + ")"
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                      _c("img", {
                                                        staticClass: "btn-icon",
                                                        attrs: {
                                                          src: require("@/assets/img/kpicon-copy.svg"),
                                                          width: "100%",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.doCopy(
                                                              v.email
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(v.userName) +
                                                    "\n                                    "
                                                ),
                                                v.email
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            "(" + v.email + ")"
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                      _c("img", {
                                                        staticClass: "btn-icon",
                                                        attrs: {
                                                          src: require("@/assets/img/kpicon-copy.svg"),
                                                          width: "100%",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.doCopy(
                                                              v.email
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ])
                                                  : _vm._e(),
                                              ],
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1046491212
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("daysOfPending")
                ? _c("el-table-column", {
                    attrs: { width: 340, "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.days_of_pending_for_authorisation"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "daysOfPendingForAuthorisation"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.order
                                            .daysOfPendingForAuthorisation ==
                                          "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.order
                                            .daysOfPendingForAuthorisation ==
                                          "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .daysOfPendingForAuthorisation
                                                          .range.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1085846887
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("input-number-range", {
                                              model: {
                                                value:
                                                  _vm.filter
                                                    .daysOfPendingForAuthorisation
                                                    .range,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter
                                                      .daysOfPendingForAuthorisation,
                                                    "range",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.daysOfPendingForAuthorisation.range",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "td" }, [
                                _c(
                                  "span",
                                  { staticClass: "overflow-tooltip-cls" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.daysOfPendingForAuthorisation
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1855052382
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("courierNo")
                ? _c("el-table-column", {
                    attrs: { width: 340 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", {
                                    staticClass: "th-label",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.courier_no"
                                        )
                                      ),
                                    },
                                  }),
                                  _c(
                                    "el-popover",
                                    {
                                      ref: "trackNumPopper",
                                      attrs: { placement: "bottom" },
                                      on: {
                                        hide: function ($event) {
                                          return _vm.filterTrackNum(
                                            _vm.filter.courierNo
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter.courierNo
                                                          .input
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2259185084
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "text-input" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                rows: 5,
                                                resize: "none",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.courierNo.input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.courierNo,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.courierNo.input",
                                              },
                                            }),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.filter.courierNo.input
                                                      .length > 0,
                                                  expression:
                                                    "filter.courierNo.input.length > 0",
                                                },
                                              ],
                                              staticClass:
                                                "el-icon-circle-close clear-btn",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.filter.courierNo.input =
                                                    ""
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "header-btn-position",
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "wl-green",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.filterTrackNum(
                                                      _vm.filter.courierNo
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("btn_search2"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "td" },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        disabled:
                                          scope.row.uniqueId.startsWith("E"),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeTrackNum(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.courierNo,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "courierNo", $$v)
                                        },
                                        expression: "scope.row.courierNo",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-s-promotion",
                                        staticStyle: {
                                          color: "rgb(56, 121, 235)",
                                          cursor: "pointer",
                                          position: "relative",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          right: "5px",
                                        },
                                        attrs: { slot: "suffix" },
                                        slot: "suffix",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1932461176
                    ),
                  })
                : _vm._e(),
              false
                ? _c("el-table-column", {
                    attrs: { width: 340 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.courier_no_2"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      ref: "trackNumPopper2",
                                      attrs: { placement: "bottom" },
                                      on: {
                                        hide: function ($event) {
                                          return _vm.filterTrackNum(
                                            _vm.filter.courierNo
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    :"
                                                    ),
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter.courierNo2
                                                          .input
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3804002594
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "text-input" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                rows: 5,
                                                resize: "none",
                                              },
                                              model: {
                                                value:
                                                  _vm.filter.courierNo2.input,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter.courierNo2,
                                                    "input",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.courierNo2.input",
                                              },
                                            }),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.filter.courierNo2.input
                                                      .length > 0,
                                                  expression:
                                                    "filter.courierNo2.input.length > 0",
                                                },
                                              ],
                                              staticClass:
                                                "el-icon-circle-close clear-btn",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.filter.courierNo2.input =
                                                    ""
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "header-btn-position",
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "wl-green",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.filterTrackNum2(
                                                      _vm.filter.courierNo2
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("btn_search2"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "td" },
                                [
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.courierTrackingNumber
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.courierTrackingNumber
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1988693529
                    ),
                  })
                : _vm._e(),
              _vm.getUser.userType === "1" &&
              _vm.showColumns.includes("dateDeliveredToAddressee")
                ? _c("el-table-column", {
                    attrs: { width: 320 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.dateDeliveredToAddressee"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "dateDeliveredToAddressee"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.order.dateDeliveredToAddressee ==
                                          "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.order.dateDeliveredToAddressee ==
                                          "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .dateDeliveredToAddressee
                                                          .range &&
                                                        _vm.filter
                                                          .dateDeliveredToAddressee
                                                          .range.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2682297832
                                      ),
                                    },
                                    [
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "daterange",
                                            format: "yyyy-MM-dd",
                                            "value-format": "yyyy-MM-dd",
                                            "range-separator": "~",
                                            "start-placeholder":
                                              _vm.$t("begin_date"),
                                            "end-placeholder":
                                              _vm.$t("end_date"),
                                          },
                                          model: {
                                            value:
                                              _vm.filter
                                                .dateDeliveredToAddressee.range,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filter
                                                  .dateDeliveredToAddressee,
                                                "range",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filter.dateDeliveredToAddressee.range",
                                          },
                                        }),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "td" },
                                [
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatDateTime")(
                                                scope.row
                                                  .dateDeliveredToAddressee
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              scope.row.dateDeliveredToAddressee
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3834505026
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("daysOfReceivedAndProcessedByAddressees")
                ? _c("el-table-column", {
                    attrs: { width: 480, "show-overflow-tooltip": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "th" },
                                [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "confirmation.details_list.table.number_of_days_since_received"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "daysOfReceivedAndProcessedByAddressees"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.order
                                            .daysOfReceivedAndProcessedByAddressees ==
                                          "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.order
                                            .daysOfReceivedAndProcessedByAddressees ==
                                          "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "th-filter-down",
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "el-icon-arrow-down",
                                                        _vm.filter
                                                          .daysOfReceivedAndProcessedByAddressees
                                                          .range.length > 0
                                                          ? "el-icon-arrow-down-active"
                                                          : "",
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        616075553
                                      ),
                                    },
                                    [
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("input-number-range", {
                                              model: {
                                                value:
                                                  _vm.filter
                                                    .daysOfReceivedAndProcessedByAddressees
                                                    .range,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filter
                                                      .daysOfReceivedAndProcessedByAddressees,
                                                    "range",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "filter.daysOfReceivedAndProcessedByAddressees.range",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "td" }, [
                                _c(
                                  "span",
                                  { staticClass: "overflow-tooltip-cls" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row
                                          .daysOfReceivedAndProcessedByAddressees
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3418521863
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("comment")
                ? _c("el-table-column", {
                    key: 14,
                    attrs: {
                      width: "100",
                      align: "center",
                      label: _vm.$t(
                        "confirmation.details_list.table.input_comments"
                      ),
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("TABLE_HEAD_COMMENTS")) +
                                      "\n                                "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.filter.commentDate.range,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.filter.commentDate,
                                          "range",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex item-center justify-center",
                                },
                                [
                                  _c("i", {
                                    class: [
                                      scope.row.todayCommentCount > 0
                                        ? "wl-icon-messageBoard"
                                        : "wl-icon-messageBoardNull",
                                      "el-icon-s-comment",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toogleMessageBoardVisible(
                                          scope.row
                                        )
                                      },
                                    },
                                  }),
                                  scope.row.todayCommentCount
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "message-today" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.todayCommentCount
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", [_vm._v("/")]),
                                      ])
                                    : _vm._e(),
                                  scope.row.messageList.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.messageList.length)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1837163906
                    ),
                  })
                : _vm._e(),
              false
                ? _c("el-table-column", {
                    attrs: { width: 120 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "th" }, [
                                _c("div", { staticClass: "th-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "confirmation.details_list.table.input_comments"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "td" },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      ref: `comment-${scope.row.uniqueId}`,
                                      attrs: {
                                        placement: "bottom",
                                        width: "250",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "th-comment-comment-input",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.comment[
                                                  scope.row.uniqueId
                                                ] ||
                                                  _vm.$t(
                                                    "confirmation.details_list.table.input_comments"
                                                  )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "confirmation.details_list.table.input_comments"
                                                ),
                                                type: "textarea",
                                                rows: 5,
                                                resize: "none",
                                                maxlength: "300",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.comment[
                                                    scope.row.uniqueId
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.comment,
                                                    scope.row.uniqueId,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "comment[scope.row.uniqueId]",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-position",
                                                  staticStyle: {
                                                    color: "#3879eb",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.sendComment(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1878482153
                    ),
                  })
                : _vm._e(),
              _vm.showColumns.includes("historicalComments")
                ? _c("el-table-column", {
                    attrs: { width: 250, fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "th" }, [
                                _c("div", { staticClass: "th-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "confirmation.details_list.table.historical_comments"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "td" },
                                [
                                  scope.row.historicalComments &&
                                  scope.row.historicalComments.length > 0
                                    ? _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "top",
                                            width: "400",
                                            trigger: "hover",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            _vm._l(
                                              scope.row.historicalComments,
                                              function (v, k) {
                                                return _c("div", { key: k }, [
                                                  _vm._v(
                                                    "\n                                    【\n                                    "
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(v.sendUserName) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(v.updateDate)
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    "\n                                    】\n                                    "
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(v.messageContent)
                                                    ),
                                                  ]),
                                                  _c("br"),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "table-td-comment",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                【\n                                "
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row
                                                      .historicalComments[0]
                                                      .sendUserName
                                                  ) + " "
                                                ),
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("formatDateTime")(
                                                        scope.row
                                                          .historicalComments[0]
                                                          .updateDate
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                                】\n                                "
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row
                                                      .historicalComments[0]
                                                      .messageContent
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      376561986
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-pagination",
            {
              staticClass: "wl-pagination",
              attrs: {
                "current-page": _vm.list.page,
                "page-size": _vm.list.limit,
                layout: "prev, pager, next, slot, total",
                total: _vm.list.total,
              },
              on: {
                "current-change": (page) => {
                  _vm.list.page = page
                  _vm.getList()
                },
              },
            },
            [
              _c(
                "span",
                [
                  _c(
                    "el-select",
                    {
                      on: {
                        change: (e) => {
                          _vm.list.page = 1
                          _vm.list.limit = e
                          _vm.getList()
                        },
                      },
                      model: {
                        value: _vm.list.limit,
                        callback: function ($$v) {
                          _vm.$set(_vm.list, "limit", $$v)
                        },
                        expression: "list.limit",
                      },
                    },
                    _vm._l(_vm.pageOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.deprecatedTicketList.length > 0
        ? _c(
            "el-popover",
            { attrs: { placement: "top", trigger: "hover", width: "700" } },
            [
              _c("div", { staticClass: "ticket-cls" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("deprecatedTicketTip", {
                        ticketList: _vm.deprecatedTicketList
                          .map((item) => item.ticketNo)
                          .join(","),
                      })
                    ) +
                    "\n        "
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "deprecated-ticket-content",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _c("div", { staticClass: "ticket-info" }, [
                    _c("span", { staticClass: "ticket-cls" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("deprecatedTicketTip", {
                            ticketList: _vm.deprecatedTicketList
                              .map((item) => item.ticketNo)
                              .join(","),
                          })
                        )
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("COMMON_SET_STATUS"),
            visible: _vm.batchUpdateVisible,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchUpdateVisible = $event
            },
            close: function ($event) {
              _vm.batchUpdateVisible = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "batchUpdateForm",
              attrs: {
                model: _vm.batchUpdateForm,
                rules: _vm.batchUpdateRule,
                "label-width": "280px",
              },
            },
            [
              _vm.checkedStatus2List.length > 0
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "confirmation.details_list.table.client_authorisation_status"
                        ),
                        prop: "status",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("COMMON_SELECT"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.batchUpdateForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.batchUpdateForm, "status", $$v)
                            },
                            expression: "batchUpdateForm.status",
                          },
                        },
                        [
                          _vm._l(
                            _vm.options.confirmationStatusOptions,
                            function (item) {
                              return [
                                item.code === "3"
                                  ? _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label: _vm.$t(
                                          "confirmation_status._3_3"
                                        ),
                                        value: item.code,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "confirmation.details_list.updateStatusForm.courier_no"
                    ),
                    prop: "courierNoOfTheConfirmationSentToKPMG",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value:
                        _vm.batchUpdateForm
                          .courierNoOfTheConfirmationSentToKPMG,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.batchUpdateForm,
                          "courierNoOfTheConfirmationSentToKPMG",
                          $$v
                        )
                      },
                      expression:
                        "batchUpdateForm.courierNoOfTheConfirmationSentToKPMG",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchUpdateVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(this.$t("btn_cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleBatchUpdateStatus },
                },
                [_vm._v(_vm._s(this.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("reprint_dialog_title"),
            visible: _vm.reprint.show,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.reprint, "show", $event)
            },
            close: function ($event) {
              _vm.reprint.show = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "reprint",
              attrs: { model: _vm.reprint, "label-width": "280px" },
            },
            [
              _c("div", {
                staticClass: "reprint_dialog_tip",
                domProps: { innerHTML: _vm._s(_vm.$t("reprint_dialog_tip")) },
              }),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("reason"), prop: "reason" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("COMMON_SELECT"),
                        clearable: "",
                        multiple: "",
                      },
                      model: {
                        value: _vm.reprint.reason,
                        callback: function ($$v) {
                          _vm.$set(_vm.reprint, "reason", $$v)
                        },
                        expression: "reprint.reason",
                      },
                    },
                    _vm._l(_vm.reprint.options, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: _vm.$t(item.label), value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.reprint.reason.includes(6)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("please_input_reason"),
                        prop: "othersReason",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: 300, "show-word-limit": "" },
                        model: {
                          value: _vm.reprint.othersReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.reprint, "othersReason", $$v)
                          },
                          expression: "reprint.othersReason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.reprint.show = false
                    },
                  },
                },
                [_vm._v(_vm._s(this.$t("btn_cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleReprint },
                },
                [_vm._v(_vm._s(this.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.messageBoardVisible
        ? _c("messageBoard", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.toogleMessageBoardVisible,
              onAdd: _vm.getList,
              messageType: "11",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }